import axios from "axios";
import type {Product, ProductListItem, ProductFilterSortType} from "@songfinch/types/types";


export type FetchProductParams = {
    slug?: string;
    getWithParent?: boolean;
}

export const fetchProduct = async (params: FetchProductParams): Promise<Product> => {
    const res = await axios.get(`/store/single_product/${params.slug}`, {
        params: {
            get_with_parent: params.getWithParent
        }
    });
    return res.data;
};

type FetchProductsParams = {
    ids?: string[];
    full?: boolean;
    name?: string[];
    coupon?: string;
    story_id?: number;
}

export const fetchProducts = async (params?: FetchProductsParams): Promise<ProductListItem[]> => {
    const res = await axios.get("/store/products", {params});
    return res.data;
};

export const fetchStoreProducts = async (params?: FetchProductParams): Promise<ProductListItem[]> => {
    const res = await axios.get("/store/index", {params});
    return res.data.products;
};

// remove undefined from type when data is coming from backend
export const fetchProductFilters = async (): Promise<ProductFilterSortType | undefined> => {
    const res = await axios.get("/store/filters");
    return res.data;
};
